export default __webpack_public_path__ + "static/media/slider2.f601e4ab.jpg";